import { h, Component } from 'preact';
import ChatFrame from './chat-frame';
import ChatFloatingButton from './chat-floating-button';
import ArrowIcon from './arrow-icon';

import {
    desktopTitleStyle,
    desktopWrapperStyle,
    mobileOpenWrapperStyle,
    mobileClosedWrapperStyle,
    desktopClosedWrapperStyleChat, circle, agent,
    agentMobile
} from "./style";

export default class Widget extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isChatOpen: false,
            pristine: true,
            wasChatOpened: this.wasChatOpened(),
            isValidKey: false
        };
    }

    componentDidMount() {
        const server = this.props.src
        const url = server + '/check_api_key';

        const urlRoot = `${window.location.origin}/`;
        const host = urlRoot || 'unknown-host';

        fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                api_key: this.props.chatgptAgentId,
                host: host,
                api_mode: this.props.conf.apiMode,
                src: server
            })
        })
            .then(response => {
                if (response.ok) {
                    return response.json();
                }
            })
            .then(responseData => {
                if (responseData) {
                    this.setState({
                        isValidKey: true
                    })
                }
            })

        if (this.props.conf.openPopupChat) {
            this.setState({
                isChatOpen: true,
                pristine: false
            });
        }
    }

    render({conf, isMobile}, {isChatOpen, pristine}) {

        const wrapperWidth = {width: conf.desktopWidth};
        const desktopHeight = (window.innerHeight - 100 < conf.desktopHeight) ? window.innerHeight - 90 : conf.desktopHeight;
        const wrapperHeight = {height: desktopHeight};

        let wrapperStyle;
        if (!isChatOpen && (isMobile || conf.alwaysUseFloatingButton)) {
            wrapperStyle = { ...mobileClosedWrapperStyle};

            if (conf.positionDisplayIconChat === 'left') {
                delete wrapperStyle.right;
            }
        } else if (!isMobile){
            if (conf.positionDisplayIconChat === 'left') {
                delete desktopWrapperStyle.right;
            }
            wrapperStyle = (conf.closedStyle === 'chat' || isChatOpen || this.wasChatOpened()) ?
                (isChatOpen) ? 
                    { ...desktopWrapperStyle, ...wrapperWidth}
                    :
                    { ...desktopWrapperStyle}
                :
                { ...desktopClosedWrapperStyleChat};
        } else {
            wrapperStyle = mobileOpenWrapperStyle;
        }

        let styleAgent = agent;
        if (isMobile) {
            styleAgent = agentMobile
        }

        if (this.state.isValidKey) {
            return (
                <div style={wrapperStyle}>

                    {/* Open/close button */}
                    { (isMobile || conf.alwaysUseFloatingButton) && !isChatOpen ?

                        <ChatFloatingButton color={conf.mainColor} onClick={this.onClick}/>

                        :
                        <div style={{background: conf.mainColor, ...desktopTitleStyle}}>
                            <div style={{ ...styleAgent }}>
                                <div className="half">
                                    <img style={{ ...circle }} src={conf.avatar}
                                         alt="avatar"></img>
                                </div>
                            </div>
                            <ArrowIcon isOpened={isChatOpen} onClick={this.onClick}/>
                        </div>
                    }

                    {/*Chat IFrame*/}
                    <div style={{
                        display: isChatOpen ? 'block' : 'none',
                        height: isMobile ? '100%' : desktopHeight
                    }}>
                        {pristine ? null : <ChatFrame {...this.props} /> }
                    </div>

                </div>
            );
        }
    }

    onClick = () => {
        let stateData = {
            pristine: false,
            isChatOpen: !this.state.isChatOpen,
        }
        if(!this.state.isChatOpen && !this.wasChatOpened()){
            this.setCookie();
            stateData.wasChatOpened = true;
        }
        this.setState(stateData);
    }

    setCookie = () => {
        let date = new Date();
        let expirationTime = parseInt(1);
        date.setTime(date.getTime()+(expirationTime*24*60*60*1000));
        let expires = "; expires="+date.toGMTString();
        document.cookie = "chatwasopened=1"+expires+"; path=/";
    }

    getCookie = () => {
        var nameEQ = "chatwasopened=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return false;
    }

    wasChatOpened = () => {
        return (this.getCookie() === false) ? false : true;
    }

}



// WEBPACK FOOTER //
// ./src/widget/widget.js